import { render } from "./VRSSettingsForm.vue?vue&type=template&id=fd837f18"
import script from "./VRSSettingsForm.vue?vue&type=script&lang=js"
export * from "./VRSSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__